import i18n from '@/i18n';

export enum ErrorType {
  pageNotFound = 'notFound',
  error = 'error',
  noPermission = 'noPermission',
}

export const ErrorTypeDesc = {
  [ErrorType.pageNotFound]: () => i18n.t('error.pageNotFound'),
  [ErrorType.error]: () => i18n.t('error.systemError'),
  [ErrorType.noPermission]: () => i18n.t('error.noPermission'),
};
